export const META_TYPE = 'powerUsageMonth';
export const META_VER = 'v1';

export const CMD_POWERUSAGEMONTH_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
